'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Badge = require('react-goose/lib/Badge');

var _Badge2 = _interopRequireDefault(_Badge);

var _Button = require('react-goose/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Choice = require('react-goose/lib/Choice');

var _Choice2 = _interopRequireDefault(_Choice);

var _Divider = require('react-goose/lib/Divider');

var _Divider2 = _interopRequireDefault(_Divider);

var _Image = require('react-goose/lib/Image');

var _Image2 = _interopRequireDefault(_Image);

var _Input = require('react-goose/lib/Input');

var _Input2 = _interopRequireDefault(_Input);

var _Label = require('react-goose/lib/Label');

var _Label2 = _interopRequireDefault(_Label);

var _Link = require('react-goose/lib/Link');

var _Link2 = _interopRequireDefault(_Link);

var _Message = require('react-goose/lib/Message');

var _Message2 = _interopRequireDefault(_Message);

var _Overlay = require('react-goose/lib/Overlay');

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Select = require('stampy/lib/component/Select');

var _Select2 = _interopRequireDefault(_Select);

var _Terminal = require('react-goose/lib/Terminal');

var _Terminal2 = _interopRequireDefault(_Terminal);

var _Text = require('react-goose/lib/Text');

var _Text2 = _interopRequireDefault(_Text);

var _Toggle = require('react-goose/lib/Toggle');

var _Toggle2 = _interopRequireDefault(_Toggle);

var _Typography = require('react-goose/lib/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _BreadcrumbList = require('react-goose/lib/list/BreadcrumbList');

var _BreadcrumbList2 = _interopRequireDefault(_BreadcrumbList);

var _BreadcrumbListItem = require('react-goose/lib/list/BreadcrumbListItem');

var _BreadcrumbListItem2 = _interopRequireDefault(_BreadcrumbListItem);

var _BulletList = require('react-goose/lib/list/BulletList');

var _BulletList2 = _interopRequireDefault(_BulletList);

var _BulletListItem = require('react-goose/lib/list/BulletListItem');

var _BulletListItem2 = _interopRequireDefault(_BulletListItem);

var _ButtonList = require('react-goose/lib/list/ButtonList');

var _ButtonList2 = _interopRequireDefault(_ButtonList);

var _ButtonListItem = require('react-goose/lib/list/ButtonListItem');

var _ButtonListItem2 = _interopRequireDefault(_ButtonListItem);

var _DividedList = require('react-goose/lib/list/DividedList');

var _DividedList2 = _interopRequireDefault(_DividedList);

var _DividedListItem = require('react-goose/lib/list/DividedListItem');

var _DividedListItem2 = _interopRequireDefault(_DividedListItem);

var _HeirarchyList = require('react-goose/lib/list/HeirarchyList');

var _HeirarchyList2 = _interopRequireDefault(_HeirarchyList);

var _HeirarchyListItem = require('react-goose/lib/list/HeirarchyListItem');

var _HeirarchyListItem2 = _interopRequireDefault(_HeirarchyListItem);

var _NavigationList = require('react-goose/lib/list/NavigationList');

var _NavigationList2 = _interopRequireDefault(_NavigationList);

var _NavigationListItem = require('react-goose/lib/list/NavigationListItem');

var _NavigationListItem2 = _interopRequireDefault(_NavigationListItem);

var _OrderedList = require('react-goose/lib/list/OrderedList');

var _OrderedList2 = _interopRequireDefault(_OrderedList);

var _OrderedListItem = require('react-goose/lib/list/OrderedListItem');

var _OrderedListItem2 = _interopRequireDefault(_OrderedListItem);

var _TabList = require('react-goose/lib/list/TabList');

var _TabList2 = _interopRequireDefault(_TabList);

var _TabListItem = require('react-goose/lib/list/TabListItem');

var _TabListItem2 = _interopRequireDefault(_TabListItem);

var _Box = require('react-goose/lib/position/Box');

var _Box2 = _interopRequireDefault(_Box);

var _Grid = require('react-goose/lib/position/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _GridItem = require('react-goose/lib/position/GridItem');

var _GridItem2 = _interopRequireDefault(_GridItem);

var _Wrapper = require('react-goose/lib/position/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _DeadEnd = require('react-goose/lib/shape/DeadEnd');

var _DeadEnd2 = _interopRequireDefault(_DeadEnd);

var _Dialog = require('react-goose/lib/shape/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Table = require('react-goose/lib/shape/Table');

var _CenteredLanding = require('./shape/CenteredLanding');

var _CenteredLanding2 = _interopRequireDefault(_CenteredLanding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Head = function Head() {
    return _react2.default.createElement('link', { href: 'https://fonts.googleapis.com/css?family=Roboto+Mono|Merriweather', rel: 'stylesheet' });
};
var Colors = {
    primary: "#527fd7",
    secondary: "#e17564",
    tertiary: "#f1dd8b"
};

module.exports = {
    // goose
    Badge: _Badge2.default,
    Button: _Button2.default,
    Choice: _Choice2.default,
    Divider: _Divider2.default,
    Head: Head,
    Image: _Image2.default,
    Input: _Input2.default,
    Label: _Label2.default,
    Link: _Link2.default,
    Message: _Message2.default,
    Overlay: _Overlay2.default,
    Select: _Select2.default,
    Terminal: _Terminal2.default,
    Text: _Text2.default,
    Toggle: _Toggle2.default,
    Typography: _Typography2.default,
    // goose list
    BreadcrumbList: _BreadcrumbList2.default,
    BreadcrumbListItem: _BreadcrumbListItem2.default,
    BulletList: _BulletList2.default,
    BulletListItem: _BulletListItem2.default,
    ButtonList: _ButtonList2.default,
    ButtonListItem: _ButtonListItem2.default,
    DividedList: _DividedList2.default,
    DividedListItem: _DividedListItem2.default,
    HeirarchyList: _HeirarchyList2.default,
    HeirarchyListItem: _HeirarchyListItem2.default,
    NavigationList: _NavigationList2.default,
    NavigationListItem: _NavigationListItem2.default,
    OrderedList: _OrderedList2.default,
    OrderedListItem: _OrderedListItem2.default,
    TabList: _TabList2.default,
    TabListItem: _TabListItem2.default,
    // goose position
    Box: _Box2.default,
    Grid: _Grid2.default,
    GridItem: _GridItem2.default,
    Wrapper: _Wrapper2.default,
    // goose shape
    DeadEnd: _DeadEnd2.default,
    Dialog: _Dialog2.default,
    Table: _Table.Table,
    TableBody: _Table.TableBody,
    TableCell: _Table.TableCell,
    TableFoot: _Table.TableFoot,
    TableHead: _Table.TableHead,
    TableHeadCell: _Table.TableHeadCell,
    TableRow: _Table.TableRow,
    // dcme shape
    CenteredLanding: _CenteredLanding2.default,
    // data
    Colors: Colors
};


//////////////////
// WEBPACK FOOTER
// ./~/dcme-style/lib/index.js
// module id = 29
// module chunks = 35783957827783 114276838955818 162898551421021